<template>
  <div class="md-layout-container" v-if="surveys">
    <modal v-if="classicModal" @close="classicModalHide">
      <template slot="header">
        <div class="p-4">
          <h4 class="modal-title">Encuesta anónima</h4>
          <p>{{ surveys.question }}</p>
          <button
            class="md-button md-simple md-just-icon md-round modal-default-button"
            @click="classicModalHide"
          >
            <i class="material-icons">clear</i>
          </button>
        </div>
      </template>

      <template slot="body">
        <div class="px-4 pb-4">
          Respuesta:
          <div class="md-field">
            <input class="md-input" v-model="answer" />
          </div>
          <button
            class="mt-3 md-button md-primary"
            :disabled="!answer"
            @click="createAnswer()"
            >Enviar</button
          >
        </div>
      </template>

      <template slot="footer"> </template>
    </modal>
  </div>
</template>
<script>
import Swal from "sweetalert2";
import permissionsMixin from "@/mixins/permissionsMixin";
import FormValidate from "@/components/FormValidate.vue";
import Modal from "./Modal.vue"; // Importa el componente modal

// Mock functions to replace non-existent imports
const getActiveSurveys = async () => {
  console.warn(
    "getActiveSurveys is not available - Surveys actions module was removed"
  );
  return { success: false, data: [] };
};

const createAnswerSurvey = async (data) => {
  console.warn(
    "createAnswerSurvey is not available - Surveys actions module was removed"
  );
  return { success: false, message: "Create answer survey not available" };
};

export default {
  mixins: [permissionsMixin],
  components: {
    FormValidate,
    Modal,
  },

  name: "Survey",

  data() {
    return {
      surveys: false,
      classicModal: true,
      answer: "",
    };
  },
  created() {
    this.loadinit();
  },
  methods: {
    classicModalHide() {
      this.classicModal = false;
    },
    async loadinit() {
      const response = await getActiveSurveys();
      this.surveys = response.surveys;
    },
    async createAnswer() {
      let data = { surveyId: this.surveys._id, answer: this.answer, stars: 1 };
      this.classicModalHide();

      Swal.fire({
        icon: "success",
        title: "Gracias",
      });

      await createAnswerSurvey(data);
    },
  },
};
</script>
